module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZD0iTTAgMGg1MTJ2NTEySDB6IiBmaWxsPSIjZWYyYjJkIi8+CiAgPHBhdGggZD0iTTEyOCAwaDEyOHY1MTJIMTI4eiIgZmlsbD0iI2ZmZiIvPgogIDxwYXRoIGQ9Ik0wIDE5Mmg1MTJ2MTI4SDB6IiBmaWxsPSIjZmZmIi8+CiAgPHBhdGggZD0iTTE2MCAwaDY0djUxMmgtNjR6IiBmaWxsPSIjMDAyODY4Ii8+CiAgPHBhdGggZD0iTTAgMjI0aDUxMnY2NEgweiIgZmlsbD0iIzAwMjg2OCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/sj.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/sj.svg
// module chunks = 0